var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var getIterator = require('get-iterator');

module.exports = function (writable) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var maybeEndSource, error, errCb, errorHandler, closeCb, closed, closeHandler, finishCb, finished, finishHandler, drainCb, drainHandler, waitForDrainOrClose, waitForDone, cleanup, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              source = getIterator(source);

              maybeEndSource = function maybeEndSource(source) {
                if (typeof source.return === 'function') source.return();
              };

              error = null;
              errCb = null;

              errorHandler = function errorHandler(err) {
                error = err;
                if (errCb) errCb(err); // When the writable errors, try to end the source to exit iteration early

                maybeEndSource(source);
              };

              closeCb = null;
              closed = false;

              closeHandler = function closeHandler() {
                closed = true;
                if (closeCb) closeCb();
              };

              finishCb = null;
              finished = false;

              finishHandler = function finishHandler() {
                finished = true;
                if (finishCb) finishCb();
              };

              drainCb = null;

              drainHandler = function drainHandler() {
                if (drainCb) drainCb();
              };

              waitForDrainOrClose = function waitForDrainOrClose() {
                return new Promise(function (resolve, reject) {
                  closeCb = drainCb = resolve;
                  errCb = reject;
                  writable.once('drain', drainHandler);
                });
              };

              waitForDone = function waitForDone() {
                // Immediately try to end the source
                maybeEndSource(source);
                return new Promise(function (resolve, reject) {
                  if (closed || finished || error) return resolve();
                  finishCb = closeCb = resolve;
                  errCb = reject;
                });
              };

              cleanup = function cleanup() {
                writable.removeListener('error', errorHandler);
                writable.removeListener('close', closeHandler);
                writable.removeListener('finish', finishHandler);
                writable.removeListener('drain', drainHandler);
              };

              writable.once('error', errorHandler);
              writable.once('close', closeHandler);
              writable.once('finish', finishHandler);
              _context.prev = 19;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 22;
              _iterator = _asyncIterator(source);

            case 24:
              _context.next = 26;
              return _iterator.next();

            case 26:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 30;
              return _step.value;

            case 30:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 41;
                break;
              }

              value = _value;

              if (!(!writable.writable || writable.destroyed || error)) {
                _context.next = 35;
                break;
              }

              return _context.abrupt("break", 41);

            case 35:
              if (!(writable.write(value) === false)) {
                _context.next = 38;
                break;
              }

              _context.next = 38;
              return waitForDrainOrClose();

            case 38:
              _iteratorNormalCompletion = true;
              _context.next = 24;
              break;

            case 41:
              _context.next = 47;
              break;

            case 43:
              _context.prev = 43;
              _context.t0 = _context["catch"](22);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 47:
              _context.prev = 47;
              _context.prev = 48;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 52;
                break;
              }

              _context.next = 52;
              return _iterator.return();

            case 52:
              _context.prev = 52;

              if (!_didIteratorError) {
                _context.next = 55;
                break;
              }

              throw _iteratorError;

            case 55:
              return _context.finish(52);

            case 56:
              return _context.finish(47);

            case 57:
              _context.next = 63;
              break;

            case 59:
              _context.prev = 59;
              _context.t1 = _context["catch"](19);

              // error is set by stream error handler so only destroy stream if source threw
              if (!error) {
                writable.destroy();
              } // could we be obscuring an error here?


              error = _context.t1;

            case 63:
              _context.prev = 63;

              // We're done writing, end everything (n.b. stream may be destroyed at this point but then this is a no-op)
              if (writable.writable) {
                writable.end();
              } // Wait until we close or finish. This supports halfClosed streams


              _context.next = 67;
              return waitForDone();

            case 67:
              if (!error) {
                _context.next = 69;
                break;
              }

              throw error;

            case 69:
              _context.prev = 69;
              // Clean up listeners
              cleanup();
              return _context.finish(69);

            case 72:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[19, 59], [22, 43, 47, 57], [48,, 52, 56], [63,, 69, 72]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};